/**
 * 申请单信息
 */
import React from 'react';

import { Input, Row, Col, Icon, Tooltip, Button, DatePicker } from 'antd';

import PageLayout from '../../ui/PageLayout';
import http from '../../../axios/http';
import moment from 'moment';    //时间

import OrgSelect from '../../ui/OrgSelect'; //组织机构
import Loading from '../../ui/Loading';

import MemberDayStatistics from './MemberDayStatistics';

class MemberStatisticsIndex extends React.Component {
    columns = [{
        title: '会员名称',
        dataIndex: 'memberName',
        width: '20%',
    }, {
        title: '累计充值金额',
        dataIndex: 'rechargeTotal',
        width: '10%',
    }, {
        title: '上月结余金额',
        dataIndex: 'lastMonthAccount',
        width: '10%',
    }, {
        title: '本月实际充值金额',
        dataIndex: 'rechargeActualAmount',
        width: '10%',
    }, {
        title: '本月赠送金额',
        dataIndex: 'rechargeGiftAmount',
        width: '10%',
    }, {
        title: '本月消费金额',
        dataIndex: 'consumeAmount',
        width: '10%',
    }, {
        title: '当前结余金额',
        dataIndex: 'account',
        width: '10%',
    }, {
        title: '操作',
        dataIndex: 'memberCode',
        width: '10%',
        render: (text, record, index) => (
            <div>
                <Tooltip title="当月每日消费情况">
                    <Icon type="eye" theme="filled" className="table-operate-icon" onClick={this.detail.bind(this, record)} />
                </Tooltip>
            </div>
        ),
    }];

    state = {
        visible: false,
        editData: {},  //编辑的数据

        loadData: '',

        queryData: {
            month: moment().format("YYYY-MM"),
        },

        memberCode: '',
    };

    detail = (info, e) => {
        this.setState({ editData: info, visible: true });
    }

    hiddenModal = () => {
        this.setState({ visible: false, editData: {} });
    }

    //导出
    download = () => {
        let queryData = this.state.queryData;
        this.setState({ showLoding: true });
        let fileName = queryData.month + " statistics.xlsx";
        http.download({
            url: '/memberAccountStatistics/downloadStatistics',
            data: queryData,
            fileName: fileName,
            success: (res) => {
                this.setState({ showLoding: false });
            }
        });
    }

    //查询
    inputSearch = (field, value) => {
        let queryData = this.state.queryData;
        queryData[field] = value;
        this.setState({ queryData: queryData });
        this.state.loadData(queryData)
    }

    //所属市场查询
    orgSelect = (value) => {
        let queryData = this.state.queryData;
        queryData["orgCode"] = value;
        this.setState({ queryData: queryData });
        this.state.loadData(queryData)
    }

    //月份查询
    queryMonthStart = (date, dateString) => {
        let { queryData } = this.state;
        queryData.month = dateString;
        this.setState({ queryData: queryData });
        this.state.loadData(queryData);
    }

    render() {
        return (
            <div style={{ width: '100%', height: '100%' }}>
                <PageLayout
                    condition={(
                        <Row>
                            <Col span={20}>
                                <Input.Search
                                    placeholder="会员名称"
                                    onSearch={this.inputSearch.bind(this, "memberName")}
                                    enterButton
                                    style={{ width: '250px', marginRight: '10px' }}
                                />
                                <DatePicker.MonthPicker onChange={this.queryMonthStart} placeholder="月份"
                                    defaultValue={moment().startOf('month')} allowClear={false} />
                                <OrgSelect style={{ width: '200px', marginLeft: '10px' }} 
                                    onChange={this.orgSelect}
                                    allowClear={true}
                                    orgType={4}
                                    treeDefaultExpandAll={true} />
                            </Col>
                            <Col span={4} style={{ textAlign: "right" }}>
                                <Button type="primary" onClick={this.download}>导出</Button>
                            </Col>
                        </Row>
                    )}
                    rowKey="memberCode"
                    url="/memberAccountStatistics/findMonthStatisticsPage"
                    columns={this.columns}
                    initParams={this.state.queryData}
                    loadData={(func) => { this.setState({ loadData: func }) }}
                />
                <MemberDayStatistics
                    visible={this.state.visible}
                    onCancel={this.hiddenModal.bind(this)}
                    editData={this.state.editData}
                    month={this.state.queryData.month}
                />
                <Loading visible={this.state.showLoding} message="正在导出，请稍候..." />
            </div>
        )
    }

}

export default MemberStatisticsIndex;